<template lang="pug">
  b-row
    .col-xl-12
      panel(:title='$t("title.position_taking_settings")' :bodyClass="'childBody'")
        b-row
          .col-sm-12.col-md-12.col-lg-12.col-xl-12
            #tblModal.table-sm.table-responsive
              .table.table.table-bordered(v-if="$store.getters.getPTSB")
                thead
                  tr
                    th.align-middle.text-nowrap(style="width:10%;") {{ $t("ui.sport_types") }}
                    th.align-middle.text-nowrap(style="width:25%;") {{ $t("ui.types") }}
                    th.align-middle.text-center.text-nowrap(style="width:15%;") {{ uplineName }}
                    th.align-middle.text-center.text-nowrap(style="width:15%;" v-show="isSearch") {{ downlineName }}
                    th.align-middle.text-center.text-nowrap(style="width:15%;" v-show="isSearch") {{ $t("ui.remaining") }}
                    th.align-middle.text-center.text-nowrap(style="width:15%;" v-show="isSearch") {{ $t("ui.min") }}
                ptTableRowSoccer(ref="ptTableRowSoccer" :isSearch="isSearch")
                ptTableRowParlay(ref="ptTableRowParlay" :isSearch="isSearch")
                ptTableRowLiveCasino(v-show="isPlatformShow('LC')" ref="ptTableRowLiveCasino" :isSearch="isSearch")
                ptTableRowSlots(v-show="isPlatformShow('SL')" ref="ptTableRowSlots" :isSearch="isSearch")
                ptTableRowLotto(v-show="$helpers.isPlatformEnabled('LO')" ref="ptTableRowLotto" :isSearch="isSearch")
                ptTableRowKeno(v-show="$helpers.isPlatformEnabled('KNno')" ref="ptTableRowKeno" :isSearch="isSearch")
                ptTableRowCockfight(v-show="$helpers.isPlatformEnabled('CF')" ref="ptTableRowCockfight" :isSearch="isSearch")
                ptTableRowLottery(v-show="$helpers.isPlatformEnabled('LTno')" ref="ptTableRowLottery" :isSearch="isSearch")

</template>

<script>
import ptTableRowSoccer from "@/components/positionTakingSearch/ptTableRowSoccer.vue";
import ptTableRowParlay from "@/components/positionTakingSearch/ptTableRowParlay.vue";
import ptTableRowLiveCasino from "@/components/positionTakingSearch/ptTableRowLiveCasino.vue";
import ptTableRowSlots from "@/components/positionTakingSearch/ptTableRowSlots.vue";
import ptTableRowLotto from "@/components/positionTakingSearch/ptTableRowLotto.vue";
import ptTableRowKeno from "@/components/positionTakingSearch/ptTableRowKeno.vue";
import ptTableRowCockfight from "@/components/positionTakingSearch/ptTableRowCockfight.vue";
import ptTableRowLottery from "@/components/positionTakingSearch/ptTableRowLottery.vue";

export default {
  components: {
    ptTableRowSoccer,
    ptTableRowParlay,
    ptTableRowLiveCasino,
    ptTableRowSlots,
    ptTableRowLotto,
    ptTableRowKeno,
    ptTableRowCockfight,
    ptTableRowLottery
  },
  props: {
    loading: false,
    accountID: "",
    platformList: {
      type: Array,
      default: []
    }
  },
  computed: {
    isSearch: function() {
      if(this.accountID) {
        return !(this.accountID.length > 8)
      } else {
        return !this.$helpers.isAgentLevel()
      }
    },
    uplineName: function() {
      switch(this.accountID.length) {
        case 2: //ss
          return this.$helpers.getUplineName(6)
        case 4: //sn
          return this.$helpers.getUplineName(5)
        case 6: //ma
          return this.$helpers.getUplineName(4)
        case 8: //ag
          return this.$helpers.getUplineName(3)
        default:
          return this.$helpers.getUplineName(2)
      }
    },
    downlineName: function() {
      switch(this.accountID.length) {
        case 2: //ss
          return this.$helpers.getUplineName(5)
        case 4: //sn
          return this.$helpers.getUplineName(4)
        case 6: //ma
          return this.$helpers.getUplineName(3)
        case 8: //ag
          return this.$helpers.getUplineName(2)
        default:
          return this.$helpers.getUplineName(1)
      }
    }
  },
  methods: {
    isPlatformShow: function(mode) {
      switch(mode){
        case "LC":
          return this.platformList.includes("LIVECASINO")
        case "SL":
          return this.platformList.includes("SLOTS")
        case "LO":
          return this.platformList.includes("LOTTO")
        case "KN":
          return this.platformList.includes("KENO")
        case "CF":
          return this.platformList.includes("COCKFIGHT")
        case "LT":
          return this.platformList.includes("LOTTERY")
      }
    }
  }
}
</script>